/**
 * Date-extensions locale Belarusian [be]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('be', {
    monthNames: ['студзень','люты','сакавік','красавік','травень','чэрвень','ліпень','жнівень','верасень','кастрычнік','лістапад','снежань'],
    monthShortNames: ['студ','лют','сак','крас','трав','чэрв','ліп','жнів','вер','каст','ліст','снеж'],
    dayNames: ['нядзеля','панядзелак','аўторак','серада','чацвер','пятніца','субота'],
    dayShortNames: ['нд','пн','ат','ср','чц','пт','сб']
});
